import React from "react";
import styles from "./Blocks.module.scss";
import { Col, Row } from "react-grid-system";
import { PAGES } from "../../../../routes/PAGES";
import { Link } from "react-router-dom";
import LangService from "../../../../services/LangService";
import cn from "classnames";
import { useCommunity } from "../../../../context/community";
import { useServerProperties } from "services/server-properties";

const AboutBlock = ({ communityInfo }) => {
  const { docs } = useServerProperties();
  const {
    community: { domain, brandConfig, senderEmail },
  } = useCommunity();
  const langMap = LangService.map.pages.welcome;
  return (
    <div>
      <Row
        className={cn(styles.block, styles.aboutBlock)}
        direction={"row-reverse"}
      >
        {domain === "columbiaalumni" ?
          <>
            <div className={styles.aboutMain}>
              {Boolean(communityInfo.notice) && <p>{communityInfo.notice}</p>}
              <div>
                <img src={brandConfig.logoUrl} alt={brandConfig.title} />
              </div>
              <div className={styles.links}>
                <Link to={PAGES.WELCOME}>{langMap.about.mainLink}</Link>
                <a
                  href={brandConfig.siteUrl}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {langMap.about.aboutLink}
                </a>
                <a
                  href={docs.policyUrl}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {langMap.about.politicsLink}
                </a>
                <a
                  href={"mailto:" + senderEmail}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {langMap.about.contactUs}
                </a>
                <a
                  href={"https://calendly.com/vd-volee"}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {langMap.about.launchLink}
                </a>
              </div>
            </div>
            <div className={styles.sub}>
              <p>
                {brandConfig.title}{" "}
                {langMap.about.description1}
              </p>
              <p>{langMap.about.description2}</p>
            </div>
          </>
          :
          <>
            <Col xs={12} md={4} className={styles.notice}>
              {Boolean(communityInfo.notice) && <p>{communityInfo.notice}</p>}
            </Col>
            <Col xs={12} md={3} className={styles.links}>
              <ul>
                <li>
                  <Link to={PAGES.WELCOME}>{langMap.about.mainLink}</Link>
                </li>
                <li>
                  <a
                    href={brandConfig.siteUrl}
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    {langMap.about.aboutLink}
                  </a>
                </li>
                <li>
                  <a
                    href={domain === "annamoney"
                      ? PAGES.PRIVATE_POLICY_ANNAMONEY
                      : docs.policyUrl
                    }
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    {langMap.about.politicsLink}
                  </a>
                </li>
                <li>
                  <a
                    href={"mailto:" + senderEmail}
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    {langMap.about.contactUs}
                  </a>
                </li>
              </ul>
            </Col>
            <Col xs={12} md={5} className={styles.about}>
              <h3>{brandConfig.title}</h3>
              <p>
                {brandConfig.title}{" "}
                {langMap.about.description1}
              </p>
              <p>{langMap.about.description2}</p>
              <a
                href={"https://calendly.com/vd-volee"}
                target={"_blank"}
                rel="noreferrer"
              >
                {langMap.about.launchLink}
              </a>
            </Col>
          </>}
      </Row>
    </div>
  );
};

export default AboutBlock;
